import React from "react";
import { S3_HOSTNAME } from '../constant/hostname';

const Notice: React.FC = () => {
  // お知らせ情報
  const notice = {
    // title: "お知らせ",
    // content: "第3回講演会のご案内\n・日時: 2025年5月24日(土) 13:00〜16:30\n・会場: 近畿大学東大阪キャンパス A館101号室\n\n",
    // // S3にアップロードされたお知らせファイルのパス
    // url: "/app/articles/250228_%E6%B0%91%E6%97%8F%E6%96%87%E5%8C%96%E7%94%9F%E7%89%A9%E5%AD%A6%E7%A0%94%E7%A9%B6%E4%BC%9A_%E3%82%AD%E3%83%83%E3%82%AF%E3%82%AA%E3%83%95%E6%A1%88%E5%86%85.pdf",
  };

  // Propsは使用しない運用にした
  return (
    <div className="container mx-auto mt-8 p-6 bg-gray-50 border border-green-500 rounded-lg shadow-lg">
  <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">第3回講演会のご案内</h2>

  <div className="text-gray-700 text-lg space-y-4">
    <p>
      <span className="font-semibold">🗓 日時: </span>
      2025年5月24日(土) 13:00〜16:30
    </p>
    <p>
      <span className="font-semibold">📍 会場: </span>
      近畿大学東大阪キャンパス A館101号室
    </p>

    <div className="pt-4 border-t border-gray-300">
      <p className="text-xl font-semibold text-gray-800 mb-2">講演申込み</p>
      <p>
        <span className="font-semibold">資格: </span> どなたでも可
      </p>
      <p>
        <span className="font-semibold">講演情報: </span>
        演者氏名,ご所属(任意),演題,講演希望時間(15〜30分間,任意)をお知らせください。
      </p>
    </div>

    <div className="pt-4 border-t border-gray-300">
      <p className="text-xl font-semibold text-gray-800 mb-2">申込み先</p>
      <p>
        📨 <a href="mailto:k4i4t1a1scitec-pro.jp" className="text-blue-600 hover:text-blue-500 underline">k4i4t1a1scitec-pro.jp</a><br />
        または<br />
        📨 <a href="mailto:tanesaka@nara.kindai.ac.jp" className="text-blue-600 hover:text-blue-500 underline">tanesaka@nara.kindai.ac.jp</a>
      </p>
    </div>
  </div>
</div>
  );
};

export default Notice;
